import axios from "axios";
import initializeAxios from "../util/Axios";

class MenuServices {
    constructor() {
        initializeAxios();
    }

    async get({ pageSize, pageIndex, searchTerm }) {
        const response = await axios.get("/api/menu", {
            params: {
                pageSize,
                pageIndex,
                searchTerm
            }
        });
        return response;
    }

    async add( values ) {
        const response = await axios.post("/api/menu/add", {
            values
        });
        return response;
    }

    async update({ id, values }) {
        const response = await axios.put("/api/menu/update", {
            id,
            values
        });
        return response;
    }

    async delete(menuId) {
        const response = await axios.put("/api/menu/delete", {
            menuId,
        });
        return response.data;
    }

    async getMenuList() {
        const response = await axios.get("/api/menuslist");
        return response.data;
      }
}

export default new MenuServices();
